import React, { useState, useEffect } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import { TbCancel } from 'react-icons/tb';
import { supplierService } from '../../services/supplierService';
import { notifyError, notifySuccess } from '../../utils/notifications';

const SupplierDetails = ({ supplierData, workshopID, onClose }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [originalData, setOriginalData] = useState({});

    useEffect(() => {
        setEditedData(supplierData);
        setOriginalData(supplierData);
    }, [supplierData]);

    const handleEdit = () => {
        setIsEditMode(true);
    };

    const handleCancel = () => {
        setEditedData(originalData);
        setIsEditMode(false);
    };

    const handleSave = async () => {
        try {
            const payload = {
                name: editedData.nombreProveedor || '',
                manager_name: editedData.nombreEncargado || '',
                address: editedData.direccion || '',
                phone: editedData.telefono || '',
                RFC: editedData.rfc || '',
                secondary_phone: editedData.telefonoSecundario || '',
                email: editedData.email || '',
            };

            await supplierService.updateSupplier(supplierData.supplier_id, payload, workshopID);
            setOriginalData(editedData);
            setIsEditMode(false);
            notifySuccess('Proveedor actualizado correctamente.');
        } catch (error) {
            console.error('Error al actualizar proveedor: ', error);
            notifyError('No se pudo actualizar el proveedor.');
        }
    };

    return (
        <div className="client-details-content">
            {/* Información del Proveedor */}
            <section className="client-info-section">
                <div className="section-header-with-button sticky-section-header">
                    <h3>Información del Proveedor</h3>
                    <div className="header-actions">
                        {!isEditMode && (
                            <button className="btn-edit-inline" onClick={handleEdit}>
                                <FaEdit /> Editar
                            </button>
                        )}
                        {isEditMode && (
                            <>
                                <button className="btn-save" onClick={handleSave}>
                                    <FaSave/> Guardar
                                </button>
                                <button className="btn-cancel" onClick={handleCancel}>
                                    <TbCancel /> Cancelar
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <div className="info-grid-editable">
                    <div className="info-field">
                        <label>Nombre del Proveedor:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.nombreProveedor || ''}
                            onChange={(e) => setEditedData({ ...editedData, nombreProveedor: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Nombre del Encargado:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.nombreEncargado || ''}
                            onChange={(e) => setEditedData({ ...editedData, nombreEncargado: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Dirección:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.direccion || ''}
                            onChange={(e) => setEditedData({ ...editedData, direccion: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Teléfono:</label>
                        <input
                            type="tel"
                            placeholder="N/A"
                            value={editedData.telefono || ''}
                            onChange={(e) => setEditedData({ ...editedData, telefono: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Teléfono Secundario:</label>
                        <input
                            type="tel"
                            placeholder="N/A"
                            value={editedData.telefonoSecundario || ''}
                            onChange={(e) => setEditedData({ ...editedData, telefonoSecundario: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>RFC:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.rfc || ''}
                            onChange={(e) => setEditedData({ ...editedData, rfc: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Correo Electrónico:</label>
                        <input
                            type="email"
                            placeholder="N/A"
                            value={editedData.email || ''}
                            onChange={(e) => setEditedData({ ...editedData, email: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SupplierDetails;
